import React, { ReactNode } from "react";
import { RCCBadge, RCCGrid, RCCIcon, RCCTooltip } from "react-common-components";
import Card from "src/components/Card";
import { StyledSpan } from "src/components/List/styles";
import Photo from "src/components/Photo";
import { useTranslation } from "src/context/Translations/context";
import { IListOKRs } from "src/pages/StrategicPlanning/Okr/interface";
import formatDate from "src/utils/formatDate";
import { DivIcons, DivWithWrap } from "./styles";

interface ICardOKR{
    data: IListOKRs;
    options: (data: IListOKRs) => ReactNode;
    onViewHierarchy: Function;
	openKRs: (id: number) => void;
}

const CardOKR: React.FC<ICardOKR> = ({
	data,
	options,
	onViewHierarchy,
	openKRs
}) => {
	const { translate, currentLanguage } = useTranslation();
	const { REACT_APP_S3_ADDRESS, REACT_APP_S3_DIRECTORY } = process.env;
	return(
		<Card
			color="purple"
			options={options(data)}
			percentage={data.percent}
			percentageColor={data.colorGraph && data.colorGraph !== null && data.colorGraph !== "" ? `#${data.colorGraph}` : undefined}
			title={`${data.oka001Codigo ? `${data.oka001Codigo} - ` : ""} ${data.oka001Titulo}`}
		>			
			<RCCGrid container item alignItems="center" >
				<DivWithWrap style={{marginRight: "0.5rem"}}>
					<Photo 
						name={data.oka001Efa005Nome}
						link={data.oka001Efa005Imagem && `${REACT_APP_S3_ADDRESS}/${REACT_APP_S3_DIRECTORY}/imagens_usuarios/${data.oka001Efa005Imagem}`}
						hover
					/>
					{data.oka001Efa005Nome}
				</DivWithWrap>
				<DivWithWrap>
					<DivWithWrap>
						<RCCIcon name="calendar" size={16} color="var(--default-color-font)" />
						{data.oka001Periodo ? data.oka001Periodo : `${formatDate(data.oka001Dtinicio, currentLanguage)} - ${formatDate(data.oka001Dtfim, currentLanguage)}`}
					</DivWithWrap>
				</DivWithWrap>
			</RCCGrid>
			<RCCGrid container item alignItems="center" justifyContent="space-between">
				<div style={{display:"flex"}}>
					{data.oka001Taa001Nome && (
						<RCCBadge color="grey" styleInline="padding: 2px 8px; font-size: 0.78rem;" >{translate("Setor")}: {data.oka001Taa001Nome}</RCCBadge>
					)}
					{data.oka001Nivel === 1 && (
						<DivIcons>
							<RCCIcon 
								name="building"
								size={16}
								color="var(--default-color-font)"
								style={{marginRight: "4px"}}
							/>
							<span>
								{translate("Organizacional")}
							</span>
						</DivIcons>
					)}
					{data.oka001Nivel === 2 && (
						<DivIcons>
							<RCCIcon 
								name="users"
								size={16}
								color="var(--default-color-font)"
								style={{marginRight: "4px"}}
							/>
							<span>
								{translate("Equipe")}
							</span>
						</DivIcons>
					)}
					{data.oka001Nivel === 3 && (
						<DivIcons>
							<RCCIcon 
								name="user"
								size={16}
								color="var(--default-color-font)"
								style={{marginRight: "4px"}}
							/>
							<span>
								{translate("Indivídual")}
							</span>
						</DivIcons>
					)}
				</div>
				<div style={{display: "flex"}}>
					<RCCTooltip
						text={`${translate("Visualizar hierarquia")} ${translate("Nível")}: ${data.level}`}
						color="purple"
						style={{ display: "flex", alignItems: "center"}}
					>
						<RCCIcon 
							name="hierarchy"
							color="var(--purple-lighter)"
							size={20}
							style={{marginRight: "4px", cursor: "pointer"}}
							onClick={() => onViewHierarchy(data.oka001Id)}
						/>
						<StyledSpan style={{ marginRight: "4px" }}>
							{data.level}
						</StyledSpan>
					</RCCTooltip>
					<RCCTooltip
						text={translate("Resultados chave")}
						color="grey"
						style={{ display: "flex", alignItems: "center"}}
					>
						<RCCIcon 
							name="key"
							color="var(--grey)"
							size={16}
							style={{marginRight: "4px", cursor: "pointer"}}
							onClick={() => openKRs(data.oka001Id)}
						/>
					</RCCTooltip>
				</div>
			</RCCGrid>
		</Card>
	);};

export default CardOKR;
